import request from 'sb-request'
import { modifyProduct } from 'common/helpers/modifiers/modifyResponse'

import productQuery from './productQuery.graphql'


const fetch = (slug) => (
  request.post('graphql?name=product', {
    body: {
      query: productQuery,
      variables: { slug: String(slug) },
    },
    withErrorModal: false,
    modifyResult: ({ product }) => {
      // backend returns null and 404 if product has 'visibility' === 'INVISIBLE' or doesn't exists
      // backend may return it with errors so we need double check in modifyResult and reject handlers
      if (!product) {
        return Promise.reject()
      }

      return modifyProduct(product)
    },
  })
)


export default {
  fetch,
}
